<script>
  import { displayLinks, links } from "@stores/features/links";

  $: areaLinks = $links.filter(link => link.type === "Area");
  $: nonAreaLinks = $links
    .filter(link => link.type !== "Area")
    .sort((a, b) => a.order - b.order);

  /**
   * Returns css text for area links
   *
   * @param {object} link
   * @returns {string}
   */
  function getStyle(link) {
    if (link.type !== "Area") {
      return "";
    }

    // eslint-disable-next-line max-len
    let style = `height: ${link.height}vh; left: calc(50% + ${link.offset_x}vh); top: ${link.offset_y}vh; width: ${link.width}vh;`;

    if (link.image_url) {
      style = `${style} background-image: url(${link.image_url});`;
    }

    return style;
  }
</script>

<style>
  .links {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .links__group {
    border: 1px solid var(--thin-shadow);
    border-radius: .75rem;
    bottom: 14rem;
    display: flex;
    flex-direction: column;
    left: 50%;
    max-width: 50vh;
    overflow: hidden;
    position: absolute;
    transform: translateX(-50%);
    width: calc(100% - 4rem);
  }

  .link--area {
    backdrop-filter: blur(3px);
    background-color: rgba(255, 255, 255, 0.05);
    background-size: cover;
    border-radius: .75rem;
    left: 50%;
    overflow: hidden;
    position: absolute;
    text-indent: -999em;
    top: 0;
  }

  .link--text {
    appearance: none;
    background: var(--primary-color);
    border: 0;
    bottom: 2rem;
    color: var(--blue);
    cursor: pointer;
    font-size: 1.6rem;
    padding: 1.6rem;
    text-align: center;
  }

  .link--text + .link--text {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  .link--image {
    overflow: hidden;
  }

  img {
    display: block;
    height: auto;
    width: 100%;
  }
</style>

{#if $displayLinks}
<div class="links">
  {#each areaLinks as link}
    <a
      class="link link--area"
      href={link.url}
      title={link.name}
      style={getStyle(link)}
      target="_blank"
    >
      {link.url}
    </a>
  {/each}
  <div class="links__group">
  {#each nonAreaLinks as link}
    <a class={`link link--${link.type.toLowerCase()}`} href={link.url} title={link.text || link.url} target="_blank">
      {#if link.type === "Text"}
        {link.text}
      {:else}
        <img src={link.image_url} alt={link.url} />
      {/if}
    </a>
  {/each}</div>
</div>
{/if}
